
export default {
  props: {
    button: {
      type: Boolean,
      default: true
    },
    limit: {
      type: Number,
      default: 9
    }
  },
  async fetch() {
    const { $content, $i18n: { locale } } = this
    this.page = await $content(locale, 'pages/categories').fetch()
  },
  data() {
    return {
      page: null
    }
  }
}
